module.exports = __webpack_public_path__ + "img/idCardFile.43687557.jpg";